import { Dialog } from "@mui/material";
import { useState, type FC } from "react";
import { privacyPolicy, termsOfUse } from "../../consts/consts";
import { BasicButton } from "../generic-components/button/Button";

export const PrivacyTermsDialog: FC = () => {
  const [isPrivacyPolicy, setIsPrivacyPolicy] = useState<boolean>(false);
  const [isTermsOfUse, setIsTermsOfUse] = useState<boolean>(false);

  return (
    <>
      <p className="privacy-and-terms">
        על ידי לחיצת המשך אתה מאשר שקראת ואישרת את{" "}
        <span className="link" onClick={() => setIsTermsOfUse(true)}>תנאי השימוש</span>{" "}
        ואת{" "}
        <span className="link" onClick={() => setIsPrivacyPolicy(true)}>מדיניות הפרטיות</span>{" "}
        של WEME
      </p>
      <Dialog
        disableScrollLock={true}
        open={isPrivacyPolicy || isTermsOfUse}
        onClose={() => {
          setIsTermsOfUse(false);
          setIsPrivacyPolicy(false);
        }}
        className="terms-privacy-dialog"
      >
        {(isPrivacyPolicy ? privacyPolicy : termsOfUse)
          .split("\n")
          .map((line, index) => {
            return (
              <p className="par-text" key={index}>
                {line}
              </p>
            );
          })}
        <BasicButton
          text="קראתי"
          onClick={() => {
            setIsPrivacyPolicy(false);
            setIsTermsOfUse(false);
          }}
        />
      </Dialog>
    </>
  );
};
